// src/router/admin/dashboard.ts
import type { RouteRecordRaw } from 'vue-router'
import { ROLE_GROUPS } from '../../constants/roleGroups' 

export const adminDashboardRoutes: RouteRecordRaw[] = [
  {
    path: 'dashboard/my-profile',
    name: 'admin.dashboard.my-profile',
    component: () => import('../../views/admin/dashboard/MyProfileView.vue'),
    meta: {title: 'My Profile', requiresAuth: true, requireRoles: ROLE_GROUPS.ADMIN_PANEL },
  },
]
